import React from 'react';
import Loadable from 'react-loadable';
import Loader from 'desktop/components/Common/BlankLoader.js';

const CheckoutLoadable = Loadable({
    loader: () => import('desktop/components/Checkout/Checkout.js' /* webpackChunkName: 'checkout' */).then(module => module.default),
    loading: () => <Loader />
});

export default CheckoutLoadable;
